module.exports = __webpack_public_path__ + "static/media/saved_beach_marker.f5ae9f43.svg";